import { Row, Col, Form, Button, Card } from "react-bootstrap";
import { VocabProfileOnboarding as Vocab } from "../../../../../../ConfigFiles/multilingual/VocabProfileOnboarding";
import { FaTrash } from "react-icons/fa";
// Context
import { useLanguage } from "../../../../../../API/Context/LanguageContext";
// Config & Maps
import { SUBSTANCE_FREQUENCY_MAP } from "../../../../../../ConfigFiles/maps/habit_frequency_map";


const HabitDetailCard = ({ 
    item, 
    index, 
    onUpdate, 
    onRemove, 
    typeOptions = [], 
    behaviorOptions = [],
    frequencyOptions = SUBSTANCE_FREQUENCY_MAP,
    isFixedType = false // True for Alcohol
}) => {
    // Consume context
    const { lan } = useLanguage();

    // --- Validation Logic (Border turns red if these are true) ---
    const currentYear = new Date().getFullYear();
    
    const behaviorInvalid = item.behavior_type === "" || item.behavior_type === null;
    const freqInvalid = item.frequency === "" || item.frequency === null;
    const qtyInvalid = item.quantity === "" || parseFloat(item.quantity) <= 0;
    const yearInvalid = !item.year_start || item.year_start.toString().length !== 4 || parseInt(item.year_start) > currentYear;

    return (
        <Card className="mb-3 border-0 bg-light p-3 shadow-sm">
            <Row className="g-2 align-items-end"> 
                
                {/* Substance Selector */}
                {!isFixedType && (
                    <Col md={4}>
                        <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.form[lan]}</Form.Label>
                        <Form.Select 
                            size="md" 
                            value={item.substance} 
                            isInvalid={!item.substance}
                            onChange={e => onUpdate(index, 'substance', e.target.value)}
                        >
                            <option value="" disabled hidden>{lan === 0 ? "Seleccionar..." : "Select..."}</option>
                            {typeOptions.map((opt) => (
                                <option key={opt.id || opt.value} value={opt.id || opt.value}>
                                    {opt.labels ? opt.labels[lan] : opt.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                )}

                {/* Motivation / Behavior Type */}
                <Col md={isFixedType ? 4 : 4}>
                    <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.motivation[lan]}</Form.Label>
                    <Form.Select 
                        size="md" 
                        value={item.behavior_type} 
                        isInvalid={behaviorInvalid}
                        onChange={e => onUpdate(index, 'behavior_type', e.target.value)}
                    >
                        <option value="" disabled hidden>{lan === 0 ? "Seleccionar..." : "Select..."}</option>
                        {behaviorOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                                {opt.labels[lan]}
                            </option>
                        ))}
                    </Form.Select>
                </Col>

                {/* Frequency */}
                <Col md={isFixedType ? 4 : 4}>
                    <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.frequency[lan]}</Form.Label>
                    <Form.Select 
                        size="md" 
                        value={item.frequency} 
                        isInvalid={freqInvalid}
                        onChange={e => onUpdate(index, 'frequency', e.target.value)}
                    >
                        <option value="" disabled hidden>{lan === 0 ? "Seleccionar..." : "Select..."}</option>
                        {frequencyOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                                {opt.labels[lan]}
                            </option>
                        ))}
                    </Form.Select>
                </Col>

                {/* Quantity */}
                <Col md={isFixedType ? 4 : 4}>
                    <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.quantity[lan]}</Form.Label>
                    <Form.Control 
                        size="md"
                        type="number" 
                        placeholder="0"
                        isInvalid={qtyInvalid}
                        value={item.quantity} 
                        onChange={e => onUpdate(index, 'quantity', e.target.value)} 
                    />
                </Col>

                {/* From Year */}
                <Col md={3}>
                    <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.from_year[lan]}</Form.Label>
                    <Form.Control 
                        size="md"
                        type="text" 
                        maxLength={4}
                        placeholder="YYYY" 
                        isInvalid={yearInvalid}
                        value={item.year_start} 
                        onChange={e => onUpdate(index, 'year_start', e.target.value.replace(/\D/g, ""))} 
                    />
                </Col>

                {/* To Year */}
                <Col md={3}>
                    <Form.Label className="xx-small fw-bold mb-1 text-uppercase text-muted">{Vocab.to_year[lan]}</Form.Label>
                    <Form.Control 
                        size="md"
                        type="text" 
                        maxLength={4}
                        placeholder="YYYY" 
                        value={item.year_end} 
                        onChange={e => onUpdate(index, 'year_end', e.target.value.replace(/\D/g, ""))} 
                    />
                </Col>

                {/* Delete Button */}
                <Col md={2} className="text-center pb-2">
                    <Button variant="link" className="text-danger p-0" onClick={() => onRemove(index)}>
                        <FaTrash />
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

export default HabitDetailCard;